export enum Severity {
    Minor = 'minor',
    Medium = 'medium',
    High = 'high'
}